const SET_ORDER = "SET_ORDER";
const SET_DEFAULT_ORDER = "SET_DEFAULT_ORDER";

export const actionTypes = {
  SET_ORDER,
  SET_DEFAULT_ORDER,
};

export const setOrder = (accessor) => ({
  type: SET_ORDER,
  payload: accessor,
});

export const setDefaultOrder = () => ({
  type: SET_DEFAULT_ORDER,
});
